import styled, { css } from 'styled-components';
import { colors, fontFamily } from 'components/styles/_variables';
import { respondTo } from '../../styles/_respondTo';

export const Wrapper = styled.div`
  position: relative;
  //cursor: pointer;
  // reset datepicker style
  .react-datepicker__header {
    background-color: #ff7828 !important;
    color: #ffffff !important;

    div {
      color: #ffffff;
    }
  }

  .react-datepicker {
    max-width: 252px;
  }

  .react-datepicker__navigation--previous {
    left: 20px;
    border-right-color: #fff;
  }

  .react-datepicker__navigation--next {
    right: 20px;
    border-left-color: #fff;
  }

  .react-datepicker__month {
    margin: 0;
  }

  .react-datepicker__month-container {
    width: 100%;
  }

  .react-datepicker__current-month {
    text-transform: capitalize;
    font-family: 'IBM Plex Sans', sans-serif;
    font-size: 18px;
    font-weight: bold;
    letter-spacing: -0.3px;
    text-align: center;
  }

  .react-datepicker__day--in-range {
    background-color: #ff7828 !important;
    color: #ffffff !important;
  }

  .react-datepicker__day-name {
    width: 36px;
  }

  .react-datepicker__day {
    width: 36px;
    line-height: 36px;
    color: #2f2f2f;
    font-family: 'IBM Plex Sans', sans-serif;
    font-size: 18px;
    text-align: center;
    border-radius: 0;
    border: solid 0.15px #fae5d6;
    margin: 0;
    padding: 0;

    &:hover {
      border-radius: 0;
    }

    &--disabled {
      font-family: 'IBM Plex Sans', sans-serif;
      opacity: 0.3;
      //border: solid 0.3px #FF7828;
      box-shadow: 0 0 0 0.3px #ff7828;
      cursor: not-allowed;
      font-size: 18px;
      font-weight: 300;
      letter-spacing: -0.3px;
      text-align: center;
      color: #ff7828;
    }
  }

  .react-datepicker__day-names {
    margin-top: 5px;
  }

  .react-datepicker__day-name {
    width: 36px;
    font-family: 'IBM Plex Sans', sans-serif;
    font-size: 18px;
    font-weight: 300;
    letter-spacing: -0.3px;
    text-align: center;
    margin: 0;
  }

  .react-datepicker__day--in-range,
  .react-datepicker__day--selected {
    font-family: 'IBM Plex Sans', sans-serif;
    border: solid 0.2px #ff7828;
    color: #ffffff;
    background-color: #ff7828;

    &:hover {
      color: #ffffff;
      background-color: #ff7828;
      border-radius: 0;
    }
  }

  .react-datepicker__day--keyboard-selected {
    //background-color: #FF7828;
    background-color: #ffffff;
    color: #2f2f2f;
  }

  .react-datepicker {
    border: none;
    z-index: 10;
    box-shadow: 0 2px 4px 0 rgba(1, 126, 138, 0.3);
    overflow: hidden;
  }

  .react-datepicker__day {
    height: 36px;
  }
`;

export const TimePickerButton = styled.button`
  border: none;
  border-bottom: 1px solid rgba(255, 144, 0, 0.3);
  display: flex;
  width: 208px;
  padding: 5px 10px;
  align-items: center;
  background-color: transparent;
`;

export const TimePickerText = styled.span`
  font-family: ${fontFamily.primary};
  text-transform: capitalize;
  margin-left: 15px;
  font-size: 16px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: -0.27px;
  color: #636262;

  ${({ failed }) =>
    failed &&
    css`
      color: ${colors.theme.danger};
    `}
`;

export const TimePickerHelperText = styled.p`
  margin-top: 5px;
  margin-bottom: 10px;
  font-family: ${fontFamily.primary};
  font-size: 14px !important;
  letter-spacing: -0.23px !important;
  color: #636262;
  text-align: left;
  font-weight: normal !important;

  ${({ failed }) =>
    failed &&
    css`
      color: ${colors.theme.danger};
    `}
`;

export const TimePickerWrapper = styled.div`
  position: ${({ pos = 'relative' }) => pos};
  ${({ pos = 'relative' }) =>
    pos === 'absolute' &&
    css`
      left: -20px;
    `}
  ${respondTo.mobile`
    z-index: 998;
    position: fixed;
    width: 100vw;
    height: 100vh;
    left: 0;
    top: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: rgba(0,0,0,.63);
  `}
`;
